import Swiper from 'swiper/bundle';
function initSwipers() {
  var swiperColor = new Swiper('.pdpn-swp_color', {
    slidesPerView: 'auto',
    mousewheel: true,
    freeMode: true,
    spaceBetween: 10
  });
  var swiperImagesMobile = new Swiper('.pdpn-mobile-swp_images', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    scrollbar: {
      el: '.swiper-scrollbar'
    }
  });
  // Return the swipers so they can be accessed from outside of this file if necessary.
  return {
    swiperColor: swiperColor,
    swiperImagesMobile: swiperImagesMobile
  };
}

// call the function, so the swipers are initialized right away
initSwipers();

// Disclaimer to click on OOO sizes Optimization
var showDisclaimerSizesOOS = function showDisclaimerSizesOOS() {
  var isMobile = window.innerWidth <= 768;
  if (isMobile) {
    var mainContainer = document.querySelector('.pdpn-main__container .title-disclaimer-container');
    var mobileContainer = mainContainer.querySelector('.disclaimer-oos-container.mobile-only');
    var disclaimerBell = mainContainer.querySelector('.disclaimer-oos-container:not(.mobile-only) svg');
    var closeButton = mobileContainer.querySelector('svg');
    var sizeLabels = document.querySelectorAll('.pdpn-main__container .pdpn-swp_size .pdpn-slide_label');
    if (disclaimerBell && mainContainer && mobileContainer) {
      disclaimerBell.addEventListener('click', function (e) {
        mainContainer.classList.add('padding-bottom');
        mobileContainer.classList.add('show');
      });
    }
    if (closeButton && mainContainer && mobileContainer) {
      closeButton.addEventListener('click', function (e) {
        mainContainer.classList.remove('padding-bottom');
        mobileContainer.classList.remove('show');
      });
    }
    if (sizeLabels && mainContainer && mobileContainer) {
      sizeLabels.forEach(function (sizeLabel) {
        sizeLabel.addEventListener('click', function (e) {
          mainContainer.classList.remove('padding-bottom');
          mobileContainer.classList.remove('show');
        });
      });
    }
  }
};
document.addEventListener("DOMContentLoaded", function () {
  var _colorInputs;
  // main product form
  // shipping and returns
  var pdpnToggleShipping = document.getElementById("pdpnToggleShipping");
  var pdpnShippingContent = document.getElementById("pdpnShippingContent");
  pdpnToggleShipping.addEventListener('click', function () {
    if (pdpnShippingContent.style.display == 'none' || pdpnShippingContent.style.display == '') {
      pdpnShippingContent.style.display = 'block';
      pdpnToggleShipping.querySelector('.plus').style.display = 'none';
      pdpnToggleShipping.querySelector('.minus').style.display = 'inline';
    } else {
      pdpnShippingContent.style.display = 'none';
      pdpnToggleShipping.querySelector('.plus').style.display = 'inline';
      pdpnToggleShipping.querySelector('.minus').style.display = 'none';
    }
  });

  // product-images-new-pdp
  //  desktop
  var pdpnDeskImagesSwiperWrapper = document.querySelector('.pdpn-desktop-swp_carrousel_images');
  var pdpnDeskImagesSlides = document.querySelectorAll('.pdpn-desktop-swp-images_slide');
  var secondDesktopSlideIndex = 2;
  var modelDesktopSlideIndex;
  pdpnDeskImagesSlides.forEach(function (slide, index) {
    var imagenElement = slide.querySelector('.pdpn-desktop-images_container img');
    if (imagenElement) {
      var imageAlt = imagenElement.getAttribute('alt');
      if (imagenElement && imageAlt.includes('[model]')) {
        modelDesktopSlideIndex = index + 1;
      }
    }
  });
  if (modelDesktopSlideIndex && modelDesktopSlideIndex !== secondDesktopSlideIndex) {
    var secondSlide = pdpnDeskImagesSwiperWrapper.querySelector("[data-pdpn-desktop-images-slide-index=\"".concat(secondDesktopSlideIndex, "\"]"));
    var modelSlide = pdpnDeskImagesSwiperWrapper.querySelector("[data-pdpn-desktop-images-slide-index=\"".concat(modelDesktopSlideIndex, "\"]"));
    pdpnDeskImagesSwiperWrapper.insertBefore(modelSlide, secondSlide);
  }

  //mobile
  var pdpnMobileImagesSwiperWrapper = document.querySelector('.pdpn-mobile-swp_carrousel_images');
  var pdpnMobileImagesSlides = document.querySelectorAll('.pdpn-mobile-swp-images_slide');
  var secondMobileSlideIndex = 2;
  var modelMobileSlideIndex;
  pdpnMobileImagesSlides.forEach(function (slide, index) {
    var imagenElement = slide.querySelector('.pdpn-mobile-images_container img');
    if (imagenElement) {
      var imageAlt = imagenElement.getAttribute('alt');
      if (imagenElement && imageAlt.includes('[model]')) {
        modelMobileSlideIndex = index + 1;
      }
    }
  });
  if (modelMobileSlideIndex && modelMobileSlideIndex !== secondMobileSlideIndex) {
    var _secondSlide = pdpnMobileImagesSwiperWrapper.querySelector("[data-pdpn-mobile-images-slide-index=\"".concat(secondMobileSlideIndex, "\"]"));
    var _modelSlide = pdpnMobileImagesSwiperWrapper.querySelector("[data-pdpn-mobile-images-slide-index=\"".concat(modelMobileSlideIndex, "\"]"));
    pdpnMobileImagesSwiperWrapper.insertBefore(_modelSlide, _secondSlide);
  }

  // product-form-new-pdp
  // variable declaration
  var pdpnItemId = document.getElementById('pdpn-item-id');
  var pdpnItemSubmit = document.getElementById('pdpn-item-submit');

  //variables
  var sizeSelected = null;
  var colorSelected = null;
  var colorInputs = null;
  // color
  var pdpnColorContainer = document.getElementById('pdpn-product__color-container');
  var pdpnColorTitle = document.querySelector('.pdpn-product__color-title');
  // const firstItemColor = pdpnColorContainer.querySelector('input');
  // const pdpnColorInputs = pdpnColorContainer.querySelectorAll('.pdpn-product__color-input');
  if (pdpnColorContainer) {
    colorSelected = pdpnColorContainer.querySelector('input').value;
    colorInputs = pdpnColorContainer.querySelectorAll('.pdpn-product__color-input');
  }

  // size
  var pdpnSizeContainer = document.getElementById('pdpn-product__size-container');
  var pdpnSizeInputContainer = document.querySelectorAll('.pdpn-product__size-container__input');
  // const firstItemSize = pdpnSizeContainer.querySelector('input');

  // variants
  var pdpnVariantOptions = document.getElementById('pdpn-variant-options_selected');
  var pdpnTitleProduct = document.querySelector('.pdpn-color-name');

  // gift-card
  var pdpnGiftCard = document.getElementById('pdpn-gift-card');

  // first load
  var swipers = initSwipers();
  var pdpnDeskImagesSwiper = swipers.swiperImagesDesktop;
  var pdpnMobileImagesSwiper = swipers.swiperImagesMobile;
  (_colorInputs = colorInputs) === null || _colorInputs === void 0 || _colorInputs.forEach(function (colorInput) {
    colorInput.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        var imagenId = colorInput.getAttribute('data-imagen-id');
        // Find the corresponding index in the main mobile carousel.
        var desktopSlideIndex = Array.from(pdpnMobileImagesSwiper.slides).findIndex(function (slide) {
          return slide.dataset.imageMobileId === imagenId;
        });
        // If the index is found, navigate to that slide in the main mobile carousel.
        if (desktopSlideIndex !== -1) {
          pdpnMobileImagesSwiper.slideTo(desktopSlideIndex);
        }
      } else {
        var _imagenId = colorInput.getAttribute('data-imagen-id');
        document.querySelector(".pdpn-desktop-swp-images_slide[data-image-desktop-id=\"".concat(_imagenId, "\"]")).scrollIntoView({
          behavior: "smooth"
        });
      }
    });
  });
  function pdpnProductAvailable(colorInputs, sizeInputs, productData, variants, itemSubmit, giftCard) {
    function isColorAvailable(colorValue) {
      return productData.variants.some(function (variant) {
        return variant.option1 === colorValue && variant.available;
      });
    }
    function updateTitleProduct(colorValue, availability) {
      if (pdpnTitleProduct) {
        pdpnTitleProduct.textContent = colorValue + (availability ? '' : ' - Sold Out');
      }
    }
    colorInputs === null || colorInputs === void 0 || colorInputs.forEach(function (colorInput) {
      var colorValue = colorInput.value;
      var colorAvailability = isColorAvailable(colorValue);
      var isSelectedColor = colorInput.checked;
      colorInput.dataset.productAvailable = colorAvailability ? 'true' : 'false';
      if (isSelectedColor) {
        updateTitleProduct(colorValue, colorAvailability);
        if (!colorAvailability) {
          itemSubmit.disabled = true;
          itemSubmit.value = 'Sold Out';
        }
        if (giftCard) {
          giftCard.textContent = colorValue;
        }

        //disclaimer OOS sizes
        var hasSwatchNotAvailableSizes = false;
        sizeInputs.forEach(function (sizeInput) {
          var sizeValue = sizeInput.value;
          var optionText = "".concat(colorValue, " / ").concat(sizeValue);
          var option = Array.from(variants.options).find(function (opt) {
            return opt.text === optionText;
          });
          if (option) {
            var checkAvailability = option.getAttribute('available');
            if (checkAvailability === 'false') {
              sizeInput.parentElement.querySelector('label').classList.add('not-available');
              hasSwatchNotAvailableSizes = true;
            }
          }
        });

        // disclaimer OOS sizes
        var disclaimerMainContainer = document.querySelector('.pdpn-main__container .title-disclaimer-container');
        var disclaimerContentContainers = document.querySelectorAll('.pdpn-main__container .title-disclaimer-container .disclaimer-oos-container');
        var disclaimerContentContainerMobile = disclaimerMainContainer && disclaimerMainContainer.querySelector('.disclaimer-oos-container.mobile-only');
        if (disclaimerContentContainers && disclaimerMainContainer) {
          disclaimerContentContainers.forEach(function (disclaimerContainer) {
            if (!hasSwatchNotAvailableSizes) {
              disclaimerContainer.style.display = 'none';
              disclaimerMainContainer.classList.remove('padding-bottom');
            } else {
              disclaimerContainer.style.display = '';
              disclaimerContentContainerMobile === null || disclaimerContentContainerMobile === void 0 || disclaimerContentContainerMobile.classList.remove('show');
              disclaimerMainContainer.classList.remove('padding-bottom');
            }
          });
        }
      }
    });
  }
  function pdpnUpdateInputValue(color, size, dataSizes, variants, itemId, itemSubmit) {
    var dataColor = "".concat(color);
    var dataColorSize = "".concat(color, " / ").concat(size);

    //v2
    var findOption = function findOption(condition) {
      var selectedOption = Array.from((variants === null || variants === void 0 ? void 0 : variants.options) || []).find(function (option) {
        return condition(option);
      });
      if (selectedOption) {
        var checkAvailability = selectedOption.getAttribute('available');
        selectedOption.selected = "selected";
        itemId.value = selectedOption.value;
        itemSubmit.disabled = checkAvailability !== 'true';
        itemSubmit.value = checkAvailability === 'true' ? 'Add to cart' : 'Sold Out';
      }
    };
    if (!dataSizes && color) {
      findOption(function (option) {
        return option.text === dataColor;
      });
    } else if (color && size === null) {
      itemSubmit.value = 'Select Size';
      itemSubmit.disabled = true;
    } else {
      findOption(function (option) {
        return option.text === dataColorSize;
      });
    }
  }
  pdpnUpdateInputValue(colorSelected, sizeSelected, itemsSizes, pdpnVariantOptions, pdpnItemId, pdpnItemSubmit);
  pdpnProductAvailable(colorInputs, pdpnSizeInputContainer, productInfo, pdpnVariantOptions, pdpnItemSubmit, pdpnGiftCard);
  pdpnColorContainer === null || pdpnColorContainer === void 0 || pdpnColorContainer.addEventListener("change", function (e) {
    colorSelected = e.target.value;
    pdpnSizeInputContainer.forEach(function (size) {
      size.parentElement.querySelector('label').classList.remove('not-available');
      size.checked = false;
    });
    pdpnUpdateInputValue(colorSelected, sizeSelected, itemsSizes, pdpnVariantOptions, pdpnItemId, pdpnItemSubmit);
    pdpnProductAvailable(colorInputs, pdpnSizeInputContainer, productInfo, pdpnVariantOptions, pdpnItemSubmit, pdpnGiftCard);
  });
  pdpnSizeContainer === null || pdpnSizeContainer === void 0 || pdpnSizeContainer.addEventListener('change', function (e) {
    var sizeSelected = e.target.value;
    pdpnUpdateInputValue(colorSelected, sizeSelected, itemsSizes, pdpnVariantOptions, pdpnItemId, pdpnItemSubmit);
  });

  // Disclaimer to click on OOO sizes Optimization
  showDisclaimerSizesOOS();
});

// load elements
window.addEventListener('load', function () {
  baguetteBox.run('.new-product-content--sizechart');
  var sizechartElement = document.getElementById("baguetteBox-slider");
  sizechartElement.addEventListener('click', function () {
    baguetteBox.hide();
  });

  //afterpay
  setTimeout(function () {
    var squarePlacementElement = document.querySelector('square-placement');
    var squarePlacementShadowRoot = squarePlacementElement.shadowRoot;
    var afterPayLogo = squarePlacementShadowRoot.querySelector('.afterpay-logo svg');
    var afterPayLink = squarePlacementShadowRoot.querySelector('.afterpay-link');
    if (afterPayLogo) afterPayLogo.setAttribute('style', 'width:70px;position:relative;left:-10px;');
    if (afterPayLink) afterPayLink.setAttribute('style', 'position:relative;left:-15px;');
  }, 300);
});